import { useState } from 'react';
import { createPortal } from 'react-dom';
import { trackCookieAccepted, trackCookieRejected } from '../utils/analytics';

const COOKIE_CONSENT_KEY = 'cookie_consent';

type ConsentValue = 'accepted' | 'rejected';

export default function CookieBanner() {
  const [visible, setVisible] = useState<boolean>(
    () => !localStorage.getItem(COOKIE_CONSENT_KEY)
  );

  const handleConsent = (value: ConsentValue) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
    if (value === 'accepted') trackCookieAccepted();
    else trackCookieRejected();
    setVisible(false);
  };

  if (!visible) return null;

  return createPortal(
    <div
      id="cookie-banner"
      role="dialog"
      aria-modal="false"
      aria-label="Zgoda na pliki cookie"
      className="fixed bottom-0 left-0 right-0 flex flex-col sm:flex-row items-center justify-between gap-6 px-5 py-6 sm:px-8"
      style={{ zIndex: 2147483647 }}
    >
      <p id="cookie-banner-text" className="text-sm text-slate-300 text-center sm:text-left max-w-2xl" style={{ paddingTop: '0.5rem' }}>
        Ta strona używa plików cookie, aby zapewnić prawidłowe działanie oraz analizować ruch (Google Analytics).
        Możesz zaakceptować wszystkie cookies lub odrzucić cookies analityczne.{' '}
        <a
          id="cookie-banner-privacy-link"
          href="#"
          className="underline text-slate-200 hover:text-white"
          style={{ color: '#cbd5e1' }}
          onClick={(e) => {
            e.preventDefault();
            window.dispatchEvent(new CustomEvent('openPrivacyPolicyModal'));
          }}
        >
          Polityka prywatności
        </a>
        .
      </p>
      <div id="cookie-banner-buttons" className="flex gap-3 shrink-0" style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
        <button
          onClick={() => handleConsent('rejected')}
          className="px-4 py-2 glass-button"
          style={{ minWidth: '100px', background: 'rgba(255,255,255,0.12)', color: '#ffffff', border: '1px solid rgba(255,255,255,0.35)', boxShadow: 'none' }}
        >
          Odrzuć
        </button>
        <button
          onClick={() => handleConsent('accepted')}
          className="px-4 py-2 glass-button"
          style={{ minWidth: '100px' }}
        >
          Akceptuj
        </button>
      </div>
    </div>,
    document.body
  );
}
